<template>
  <div class="background-image-wrap">
    <img
      class="home-bgi"
      src="../assets/pc/background.png"
      alt="uyu"
    >
  </div>
</template>
<script>
export default {
  name: "home-bg-image",
  inject: ["app"],
  data() {
    return {
      
    };
  },
  components: {},
  computed: {},
  methods: {},
  mounted() {
    // 模板编译/挂载之后
  },
  created() {
    
  },
  beforeDestroy() {
    // 组件销毁前调用
    // Tips：你确认删除XX吗？
  },
  destroyed() {
    // 组件销毁后调用
    // Tips：当前组件已被删除，清空相关内容
  },
  // 数据监听
  watch: {
    "$route.name": {
      handler(curVal, oldVal) {
        // this.map && this.clearCurrentOverlays() && this.map.reset();
      },
    },
  },
};
</script>
<style lang="less" scoped>
.background-image-wrap {
  width: 100%;
  height: 100%;
  position: absolute;

  .home-bgi {
    width: 100% !important;
    height: 100% !important;
  }
}

.uppop-content {
  font-family: "微软雅黑";
  font-size: 12px;
  font-weight: 400;
  color: #111e39;
  padding: 10px 20px;
}
.uppop-content li {
  list-style: none;
  padding: 0;
  margin: 0;
}
.uppop-content li:first-child,
.uppop-content li span:first-child {
  font-weight: 800;
}

/deep/ .area-point-num {
  text-align: center;
}

/deep/.uppop-content {
  font-family: "微软雅黑";
  font-size: 12px;
  font-weight: 400;
  color: #111e39;
  padding: 1.6rem 1rem !important;
  font-family: AlibabaPuHuiTi-Regular;

  li {
    list-style: none;
    margin: 0;
    margin-bottom: 4px;
    padding: 0 10px;
  }

  li:first-child,
  li span:first-child {
    font-weight: 800;
  }
}

.zyu-brand {
  .com-honor {
    display: none;
  }
}
</style>